export default __webpack_public_path__ + "static/media/logo.ab8a2325.png";